export const VALID_WIDGET_ACTIONS = ['show', 'hide', 'open', 'close'] as const;

export type WidgetAction = (typeof VALID_WIDGET_ACTIONS)[number];
